(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-product-size-chart"] && !Shopify.designMode) return;
  try {
    const initBayamaraCharts = () => {
    document.querySelectorAll('[data-bm-chart]:not([data-bm-chart-ready])').forEach(chart => {
      chart.dataset.bmChartReady = 'true';
      const normalize = value => value.trim().toUpperCase()
        .replace(/[†*]+$/, '')
        .replace(/^XXL$/, '2XL')
        .replace(/^XXXL$/, '3XL')
        .replace(/^XXXXL$/, '4XL')
        .replace(/^XXXXXL$/, '5XL')
        .replace(/^XXXXXXL$/, '6XL');
      const offered = new Set((chart.dataset.bmOffered || '').split('|').map(normalize).filter(Boolean));
      const isSize = value => /^(?:XXS|XS|S|M|L|[2-6]?XL|\d{1,2}W?|ONESIZE)$/.test(normalize(value));
      const unitForHeader = value => {
        const label = value.replace(/\s+/g, ' ').trim().toLowerCase();
        if (/\bcm\b|centimet/.test(label)) return 'cm';
        if (/\binch(?:es)?\b|\(in\)/.test(label)) return 'inch';
        return '';
      };
      const hideColumn = (table, index) => {
        Array.from(table.rows).forEach(row => {
          if (row.cells[index]) row.cells[index].hidden = true;
        });
      };
      Array.from(chart.querySelectorAll('[data-bm-chart-unit]')).forEach(group => {
        const table = group.querySelector('table');
        const header = table?.rows[0];
        if (!header) return;
        const headerUnits = Array.from(header.cells).map(cell => unitForHeader(cell.textContent));
        if (!headerUnits.includes('inch') || !headerUnits.includes('cm')) return;
        const inchGroup = group.cloneNode(true);
        const cmGroup = group.cloneNode(true);
        [[inchGroup, 'inch'], [cmGroup, 'cm']].forEach(([copy, unit]) => {
          copy.dataset.bmChartUnit = unit;
          const copyTable = copy.querySelector('table');
          const copyHeader = copyTable.rows[0];
          Array.from(copyHeader.cells).forEach((cell, index) => {
            const columnUnit = unitForHeader(cell.textContent);
            if (columnUnit && columnUnit !== unit) hideColumn(copyTable, index);
            if (columnUnit === unit) cell.textContent = cell.textContent.replace(/\s*\((?:cm|in(?:ch)?)\)\s*/gi, '');
          });
        });
        group.before(inchGroup, cmGroup);
        group.remove();
      });
      const convertNumber = (value, from, to) => {
        const converted = from === 'inch' && to === 'cm' ? value * 2.54 : value / 2.54;
        return converted.toFixed(1).replace(/\.0$/, '');
      };
      const convertGroup = (source, from, to) => {
        const copy = source.cloneNode(true);
        copy.dataset.bmChartUnit = to;
        const table = copy.querySelector('table');
        const first = table?.rows[0];
        if (!first) return copy;
        const columnSizes = Array.from(first.cells).slice(1).some(cell => isSize(cell.textContent));
        const rowSizes = Array.from(table.rows).slice(1).some(row => row.cells[0] && isSize(row.cells[0].textContent));
        const measurementHeader = value => /bust|chest|waist|hip|length|width|height|hem|underbust|thigh|inseam|outseam|torso/i.test(value);
        Array.from(table.rows).forEach((row, rowIndex) => {
          if (!rowIndex) {
            Array.from(row.cells).forEach(cell => {
              cell.textContent = cell.textContent
                .replace(/\bINCH(?:ES)?\b|\bIN\b/gi, to === 'cm' ? 'CM' : 'INCH')
                .replace(/\bCM\b/gi, to === 'inch' ? 'INCH' : 'CM');
            });
            return;
          }
          const rowLabel = row.cells[0]?.textContent.trim() || '';
          const isRegionRow = /^(?:US|UK|AU|EU|EUR|AU\s*\/\s*UK)$/i.test(rowLabel);
          if (isRegionRow) return;
          if (!columnSizes && rowSizes && !isSize(rowLabel)) return;
          Array.from(row.cells).slice(1).forEach((cell, index) => {
            const header = first.cells[index + 1]?.textContent || '';
            if (rowSizes && !columnSizes && !measurementHeader(header) && unitForHeader(header) !== from) return;
            cell.textContent = cell.textContent.replace(/-?\d+(?:\.\d+)?/g, match => convertNumber(Number(match), from, to));
          });
        });
        source.after(copy);
        return copy;
      };
      let groups = Array.from(chart.querySelectorAll('[data-bm-chart-unit]'));
      let units = new Set(groups.map(group => group.dataset.bmChartUnit));
      if (!units.has('cm') && units.has('inch')) convertGroup(groups.find(group => group.dataset.bmChartUnit === 'inch'), 'inch', 'cm');
      groups = Array.from(chart.querySelectorAll('[data-bm-chart-unit]'));
      units = new Set(groups.map(group => group.dataset.bmChartUnit));
      if (!units.has('inch') && units.has('cm')) convertGroup(groups.find(group => group.dataset.bmChartUnit === 'cm'), 'cm', 'inch');
      groups = Array.from(chart.querySelectorAll('[data-bm-chart-unit]'));
      groups.forEach(group => group.querySelectorAll('table').forEach(table => {
        const first = table.rows[0];
        if (!first) return;
        const headerSizes = Array.from(first.cells).slice(1).filter(cell => isSize(cell.textContent));
        if (headerSizes.length) {
          Array.from(first.cells).forEach((cell, index) => {
            if (index && offered.size && isSize(cell.textContent) && !offered.has(normalize(cell.textContent))) hideColumn(table, index);
          });
          return;
        }
        Array.from(table.rows).slice(1).forEach(row => {
          const label = row.cells[0]?.textContent || '';
          if (offered.size && isSize(label) && !offered.has(normalize(label))) {
            row.hidden = true;
          }
        });
      }));
      if (!groups.length) return;
      const show = unit => {
        const active = groups.some(group => group.dataset.bmChartUnit === unit) ? unit : groups[0].dataset.bmChartUnit;
        groups.forEach(group => group.hidden = group.dataset.bmChartUnit !== active);
        chart.querySelectorAll('[data-bm-set-unit]').forEach(button => {
          button.hidden = !groups.some(group => group.dataset.bmChartUnit === button.dataset.bmSetUnit);
          button.setAttribute('aria-pressed', String(button.dataset.bmSetUnit === active));
        });
      };
      chart.querySelectorAll('[data-bm-set-unit]').forEach(button => button.addEventListener('click', () => show(button.dataset.bmSetUnit)));
      show(chart.dataset.bmDefaultUnit);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBayamaraCharts, {once: true});
  else initBayamaraCharts();
  document.addEventListener('shopify:section:load', initBayamaraCharts);

  const removeBayamaraDuplicateTables = () => {
    const details = document.querySelector('.bm-pdp-accordions[data-bm-sizes] > .bm-pdp-accordion > .bm-pdp-accordion__content');
    if (!document.querySelector('[data-bm-chart] table') || !details) return;
    details.querySelectorAll('table').forEach(table => {
      if (!/size|bust|waist|hip/i.test(table.textContent)) return;
      const container = table.closest('.chart-section, .table-responsive');
      if (container) {
        const title = container.previousElementSibling;
        if (title?.classList.contains('table-title')) title.remove();
        container.remove();
      } else table.remove();
    });
    details.querySelectorAll('.bm-size-units').forEach(control => control.remove());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeBayamaraDuplicateTables, {once:true});
  else removeBayamaraDuplicateTables();
  } catch(e) { console.error(e); }
})();

})();
